import { Injectable } from '@angular/core';
import { StorageWebService } from './storage.service';

@Injectable()
export class SessionStorageService extends StorageWebService {
  constructor() {
    super(sessionStorage);
  }
}
